export const DEFAULT_BRAND_COLOR = 'electric-violet';
export const BRAND_COLORS = [
  { id: 'electric-violet', name: 'Electric Violet', hex: '#9455F5' },
  { id: 'hot-rose', name: 'Hot Rose', hex: '#F43F7D' },
  { id: 'acid-yellow', name: 'Acid Yellow', hex: '#E5F13A' },
];
export const brandColorById = (id) =>
  BRAND_COLORS.find((color) => color.id === id);

// Lioness 01: approved primary Ada mark. Keep app and favicon geometry in sync.
export const ADA_MARK_PATHS = [
  'M17 23C10 23 9 16 13 13Q18 10 22 16Q36 10 50 17Q55 12 60 15C64 19 61 25 56 26L58 34L54 45L47 51Q43 60 36 62Q27 60 23 52L16 46L12 34Z M15 16L15 20L20 19Z M54 18L53 22L58 21Z M19 29Q24 27 29 31L25 34L20 32Z M42 31Q47 26 53 29L51 32L45 34Z M28 34L30 35L28 42L26 43Z M42 35L44 34L47 42L45 43Z M29 44Q36 40 43 44L39 49H33Z M35 49H38V53Q42 56 47 51L49 53Q43 60 36 56Q29 60 23 54L25 52Q30 56 35 53Z',
];
export function brandIconSVG(hex = '#9455F5') {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88"><rect width="88" height="88" rx="20" fill="#202020"/><g transform="translate(8 8)" fill="${hex}">${ADA_MARK_PATHS.map((d) => `<path fill-rule="evenodd" d="${d}"/>`).join('')}</g></svg>`;
}
